import { useEffect, useState } from 'react';

function getGlobalFooter() {
  const taggedFooter = document.querySelector('[data-kp-global-footer]');
  if (taggedFooter) return taggedFooter;

  const footers = document.querySelectorAll('footer');
  return footers[footers.length - 1] || null;
}

function getVisibleFooterHeight(footer) {
  if (!footer) return 0;

  const rect = footer.getBoundingClientRect();
  if (rect.height <= 0) return 0;

  const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
  const visibleHeight = Math.min(rect.height, viewportHeight - rect.top);
  return Math.max(0, visibleHeight);
}

export default function useFooterAwareFabBottom(baseBottom = 24) {
  const [bottom, setBottom] = useState(baseBottom);

  useEffect(() => {
    let frameId = 0;

    const updateBottom = () => {
      frameId = 0;
      const footer = getGlobalFooter();
      const nextBottom = Math.round(baseBottom + getVisibleFooterHeight(footer));
      setBottom((prevBottom) => (prevBottom === nextBottom ? prevBottom : nextBottom));
    };

    const scheduleUpdate = () => {
      if (frameId) return;
      frameId = window.requestAnimationFrame(updateBottom);
    };

    scheduleUpdate();
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);

    let resizeObserver = null;
    const footer = getGlobalFooter();
    if (footer && typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(scheduleUpdate);
      resizeObserver.observe(footer);
    }

    return () => {
      if (frameId) {
        window.cancelAnimationFrame(frameId);
      }
      window.removeEventListener('scroll', scheduleUpdate);
      window.removeEventListener('resize', scheduleUpdate);
      resizeObserver?.disconnect();
    };
  }, [baseBottom]);

  return bottom;
}